"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolinTagEnum = exports.Interval = exports.VideoQualityEnum = void 0;
var VideoQualityEnum;
(function (VideoQualityEnum) {
    VideoQualityEnum["quality720p"] = "720p_3";
    VideoQualityEnum["quality1080p"] = "1080p_1";
    VideoQualityEnum["quality1440p"] = "1440p_1";
})(VideoQualityEnum = exports.VideoQualityEnum || (exports.VideoQualityEnum = {}));
var Interval;
(function (Interval) {
    Interval["month"] = "month";
    Interval["year"] = "year";
})(Interval = exports.Interval || (exports.Interval = {}));
var SolinTagEnum;
(function (SolinTagEnum) {
    SolinTagEnum["hiit"] = "HIIT";
    SolinTagEnum["strength"] = "Strength";
    SolinTagEnum["dance"] = "Dance";
    SolinTagEnum["cycling"] = "Cycling";
    SolinTagEnum["pilates"] = "Pilates";
    SolinTagEnum["sports"] = "Sports";
})(SolinTagEnum = exports.SolinTagEnum || (exports.SolinTagEnum = {}));
